// extracted by mini-css-extract-plugin
module.exports = {"asterisk":"Input_asterisk__2imgX","error":"Input_error__8w3VS","errorPlaceholder":"Input_errorPlaceholder__Mx_hI","hidden":"Input_hidden__14eNp"};